<template>
    <v-dialog v-model="dialog" max-width="1400" persistent>
      <v-card>
          <v-card-title class="primary white--text title" v-if="!maintenance_id">
              {{'Add Maintenance Record'|translate}}
          </v-card-title>
          <v-card-title class="primary white--text title" v-if="maintenance_id">
              {{'Edit Maintenance Record'|translate}}
          </v-card-title>
          <v-card-text>
              <v-layout row>
                  <v-flex xs6>
                      <equipment-selector v-model="equip"></equipment-selector>
                      <v-text-field :label="'Fault'|translate" autofocus v-model="label"></v-text-field>
                      <v-text-field :label="'Maintenance ID'|translate"  v-if="maintenance_id" v-model="maintenance_id" readonly></v-text-field>
                      <date-range-selector v-model="range"></date-range-selector>
                      <severity-selector v-model="severity" :label="'Severity'|translate"></severity-selector>
                      <v-text-field :label="'Reference URL'|translate" v-model="url"></v-text-field>
                      <v-checkbox v-model="isFixed" :label="'Fixed?'|translate" @change="change_isFixed" :disabled="isFixed"></v-checkbox>
                      <v-checkbox v-model="exclude_in_model" v-if="showexclude" :label="'Normal maintenance record'|translate"></v-checkbox>
                      <v-autocomplete
                              :items="userNames"
                              :label="'Assigned to'|translate"
                              v-model="assigned_to"
                              @change="change_assigned_to"
                      ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 class="ml-3">
                      <v-textarea :label="'Description'|translate" v-model="description" auto-grow>
                      </v-textarea>
                      <v-timeline dense clipped>
                          <v-timeline-item
                                  fill-dot
                                  color="white"
                                  class="white--text mb-5"
                          >

                              <v-text-field
                                      v-model="input"
                                      hide-details
                                      flat
                                      :label="'Comment'|translate"

                                      @keydown.enter="comment"
                              >
                                  <template v-slot:append>
                                      <v-btn
                                              class="mx-0 primary"
                                              depressed
                                              @click="comment"
                                      >
                                          {{'Add'|translate}}
                                      </v-btn>
                                  </template>
                              </v-text-field>
                          </v-timeline-item>

                          <v-slide-x-transition
                                  group
                          >
                              <v-timeline-item
                                      v-for="comment in timeline"
                                      :key="comment.time+comment.text"
                                      class="mb-3"
                                      color="white"
                                      small
                              >
                                  <v-layout justify-space-between>
                                      <v-flex xs10 v-text="comment.text"></v-flex>
                                      <v-flex xs2 text-xs-right>{{comment.time}}<br/>{{comment.user}}</v-flex>
<!--                                      <v-flex xs1 text-xs-right><v-icon-->
<!--                                              small-->
<!--                                              @click="deleteComment(comment)"-->
<!--                                      >-->
<!--                                          fa-trash-->
<!--                                      </v-icon></v-flex>-->
                                  </v-layout>
                              </v-timeline-item>
                          </v-slide-x-transition>
                        </v-timeline>
                  </v-flex>
              </v-layout>

          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" v-if="maintenance_id&&notification_id" @click="openNotif">
                  <v-icon class="mr-2">fa-bell</v-icon>
                  {{'View Notification'|translate}}
              </v-btn>
              <v-btn class="accent" v-if="url" @click="jumpToLink(url)">
                  <v-icon class="mr-2">fa-chart-line</v-icon>
                  {{'View Reference Link'|translate}}
              </v-btn>
              <v-btn class="accent" v-if="url"  @click="jumpToLinkNW(url)">
                  <v-icon class="mr-2">fa-chart-line</v-icon>
                  {{'View Reference Link in New Tab'|translate}}
              </v-btn>
              <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'MaintenanceRecord')">{{'Save'|translate}}</v-btn>
              <v-btn @click="dialog=false">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import DateRangeSelector from './DateRangeSelector'
  import EquipmentSelector from './EquipmentSelector'
  import SeveritySelector from "./SeveritySelector";
  import moment from 'moment'
  import {putMaintenanceRecord,getUser} from '../helper'

  export default {
    components: { EquipmentSelector, DateRangeSelector ,SeveritySelector},
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (original) {
        this.reactToItem(original)
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
          if(!this.item){
              this.initializeVar()
          }

      }
    },
      computed: {
          timeline () {
              return this.comments.slice().sort((a, b) => (a.time < b.time) ? 1 : -1)
          },
          username () {
              if (this.$store.state.userStore.user) {
                  return this.$store.state.userStore.user.content.user_name
              }
              return null;
          },
          showexclude () {
              if (this.$store.state.userStore.user) {
                  if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                      return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                  } else {
                      return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                  }
              }
              return false;
          },
      },
    data () {
      return {
        dialog: false,
          userEmails: {},
        equip: null,
          comments:[],
          input: null,
        isFixed: false,
        range: null,
          exclude_in_model:true,
        label: '',
          severity: 'low',
        description: '',
        url: '',
          userNames:[],
          assigned_to:null,
        maintenance_id: null,
        notification_id: null
      }
    },
      mounted(){
          this.reactToItem(this.item)
      },
    methods: {
        reactToItem(original){
            this.initializeVar()
            if (original){
                let item= JSON.parse(JSON.stringify(original))
                this.facility_name = item['facility_name']
                this.equip= item['equipment']
                this.comments= item['comments'] ? item['comments'] : []
                this.range = {start: item['maintenance_date_from'], end: item['maintenance_date_to']}
                this.description = item['maintenance_text']
                this.label = item['maintenance_label']
                this.exclude_in_model = item['exclude_in_model']===false ? false : true,
                    this.url = item['url']
                if(item['severity']){
                    this.severity = item['severity']
                }
                this.isFixed = item['is_fixed']
                this.maintenance_id = item['maintenance_id']
                this.assigned_to = item['assigned_to']
                this.notification_id = item['notification_id']
                if (!this.maintenance_id) {
                    this.addComment(this.username + ' created this task')
                }
            }
        },
        jumpToLink (url) {
            if (url.startsWith('http'))
                window.open(url, '_blank')
            else {
                this.$router.push(url)
            }
        },
        jumpToLinkNW(url) {
            if (process.env.VUE_APP_SINGLE_WINDOW_MODE){
                window.location.href=url
            } else {
                window.open(url)
            }
        },
        change_assigned_to () {
                this.addComment(this.username + this.$options.filters.translate(' assigned this to ') + this.assigned_to)
        },
        change_isFixed () {
            if (this.isFixed) {
                this.addComment(this.username + this.$options.filters.translate(' fixed this'))
            } else {
                this.addComment(this.username + this.$options.filters.translate(' required fixing'))
            }
        },
        comment () {
            this.addComment(this.input)
            this.input = null
        },
        openNotif(){
            let url='/notifications?id='+this.notification_id
            if (process.env.VUE_APP_SINGLE_WINDOW_MODE){
                window.location.href=url
            } else {
                window.open(url)
            }
        },
        addComment (message) {
          this.comments.push({
                text: message,
                time: moment().format('YYYY-MM-DD HH:mm:ss'),
                user:this.username
            })
        },
        deleteComment(comment){
            this.comments.splice(this.comments.indexOf(comment), 1)
        },
      initializeVar() {
        this.equip= null
        this.isFixed= false
        this.exclude_in_model= true
        this.assigned_to= null
        this.comments= []
        this.label= ''
        this.description=''
        this.url= ''
        this.maintenance_id = null
      },
      async addRecord () {
          await putMaintenanceRecord(
              {
                  'maintenance_id': this.maintenance_id,
                  'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                  'equipment_name': this.equip,
                  'comments': this.comments,
                  'maintenance_date_from': this.range.start,
                  'maintenance_date_to': this.range.end,
                  'exclude_in_model': this.exclude_in_model,
                  'maintenance_text': this.description,
                  'maintenance_label': this.label,
                  'assigned_to': this.assigned_to,
                  'assigned_to_email': this.assigned_to&&this.userEmails[this.assigned_to] ? this.userEmails[this.assigned_to] : null,
                  'url': this.url,
                  'severity': this.severity,
                  'notification_id': this.notification_id,
                  'is_fixed': this.isFixed
              }
          )
          this.$emit('doreload')
          this.dialog=false
      }
    },
    name: 'FaultRecordDialog',
      async beforeMount() {
          let df = await getUser({
              apiBaseUrl: process.env.VUE_APP_USERS_BASE_URL ? process.env.VUE_APP_USERS_BASE_URL : null,
          })
          this.userNames=df.users.map(x=>x.user_name)
          this.userNames.sort()
          let userEmails={}
          for (let user of df.users){
              userEmails[user.user_name]=user.email
          }
          this.userEmails=userEmails
      }
  }
</script>

<style scoped>

</style>
